// action常量
export const LOGIN_ACTION = 'loginAction'

// mutations常量
export const LOGIN_M = 'login'
export const LOGOUT_M = 'logout'
export const SET_ERROR_MESSAGE_M = 'setErrorMessage'
export const ROMOVE_ERROR_MESSAGE_M = 'removeErrorMessage'
